import moment from 'utils/moment';
import { TASKS_LIST, TASK_DETAILS, TOGGLE_COMPLETE_TASK, UPDATE_TASK, RESET_COMPLETE_TASK } from './types';

const BACKEND_API = 'BACKEND_API';

export const resetCompleteTask = () => ({
  type: RESET_COMPLETE_TASK
});

export const fetchTasks = (page = 1, s, f, isCompleted = false) => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: `${isCompleted ? '/portal_tasks/completed/' : '/portal_tasks/'}?page=${page}${s ? `&s=${s}` : ''}${f ? `&f=${f}` : ''}`,
    ...TASKS_LIST
  }
});

export const fetchTaskDetails = (id, start_date) => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: `/portal_tasks/${id}${start_date ? `?start_date=${start_date}` : ''}`,
    ...TASK_DETAILS
  }
});

export const toggleCompleteTask = (oc, comment = '', completed_date = moment().format()) => {
  const id = oc?.event?.id || oc?.id || oc?.task_occurrences?.occurrence?.event?.id;
  const date = oc?.task_occurrences?.occurrence?.original_end || oc?.event?.original_end || oc?.selected_occurrence_date;

  return {
    type: BACKEND_API,
    payload: Object.assign(
      {
        method: 'post',
        url: `/portal_tasks/${id}/toggle_complete_task/`,
        data: {
          date,
          email_date: moment().format(),
          comment,
          completed_date,
          attachments: oc?.completeAttachments || []
        }
      },
      TOGGLE_COMPLETE_TASK
    )
  };
};

export const updateTaskOccurrence = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'post',
    url: `/portal_tasks/${id}/update_occurrence/`,
    data,
    ...UPDATE_TASK
  }
});
